module.exports = __webpack_public_path__ + "img/servicetext-md.0c7c2b0a.png";